import React, { useState, useEffect } from "react";
import PageviewsChartWrapper from "./pageviewsChart.style";
import { Line } from "react-chartjs-2";
import customTooltip from "components/common/chartTooltip";
import {
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import classnames from "classnames";

const PageviewsChartWidget = (props) => {

  const [activeTab, setActiveTab] = useState("shield");
  const [navItems, setNavItems] = useState([]);
  const [scale, setScale] = useState({});
  var _scaleItems = [];
  var _navItems = [];
  var interval;
  const [dataSet, setDataSet] = useState({
    "dataset1": [],
    "dataset2": []
  })


  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      clearInterval(interval);
    }
  };

  var dataset1Data = [];
  var dataset2Data = [];


  useEffect(() => {

      interval = setInterval(() => {
      let _tab = activeTab
      for (var index in Object.entries(navItems)){
        if (navItems[index]["key"] === _tab) {
          if (index !== "6" ) {
            setActiveTab(navItems[parseInt(index)+1]["key"])
          } else {
            setActiveTab(navItems[0]["key"])
          }
        } else if (_tab === '') {
          setActiveTab(navItems[0]["key"])
        }
      }
    }, 5000);
    return () => {return clearInterval(interval)};

  });
  useEffect(() => {
    if(props.data) {

      if(props.data.attr){
        if(Array.isArray(props.data.attr.date) && props.data.attr.date.length) {
        
          Object.keys(props.data).map((key) => {
            dataset1Data[key] = []
            dataset1Data[key]["date"] = []
            dataset1Data[key]["status"] = []
            dataset1Data[key]["data"] = []
            dataset1Data[key]["attr"] = {}
            
            dataset2Data[key] = []
            dataset2Data[key]["date"] = []

            dataset2Data[key]["data"] = []
            dataset2Data[key]["status"] = []
            dataset2Data[key]["attr"] = {}

            return true;
          })

          for (var index in props.data) {

            if(index === "attr"){

              props.data.attr.date.map(function(val) {
                return dataset1Data[index]["date"].push(val)
              })
            } else {

              dataset1Data[index]["attr"] = props.data[index].attr
              dataset2Data[index]["attr"] = props.data[index].attr
              //datasetAttr = props.data[index].attr
              _navItems.push(props.data[index].attr)
                
              props.data[index].data.map(function(val) {

                var value1 = val.val1 ? val.val1.slice(0, -1) : undefined;

                
                var value2 = val.val2 ? val.val2.slice(0, -1) : undefined;
                if(val.val2 && val.val1) {
                  if (val.val2[val.val2.length - 1] === "R" && val.val1[val.val1.length - 1] === "K"){
                    value1 = val.val1[val.val1.length - 1] === "K" ? value1 * 1000 : value1;
                    _scaleItems[index] = "R"
                  }
                  if (val.val2[val.val2.length - 1] === "K" && val.val1[val.val1.length - 1] === "R"){
                    value2 = val.val2[val.val2.length - 1] === "K" ? value2 * 1000 : value2;
                    _scaleItems[index] = "R"


                  }
                  if (val.val2[val.val2.length - 1] === val.val1[val.val1.length - 1]){
                    _scaleItems[index] = val.val2[val.val2.length - 1]
                  }
                } else if (val.val2 || val.val1) {
                  _scaleItems[index] = val.val2 ? val.val2[val.val2.length - 1] : val.val1[val.val1.length - 1]
                }
        
                dataset1Data[index]["data"].push(
                  parseFloat(value1)
                )
                dataset1Data[index]["status"].push(val.status)

                dataset2Data[index]["data"].push(
                  parseFloat(value2)
                )
                dataset2Data[index]["status"].push(val.status)
                return true
              })
            }

          }
          setDataSet({dataset1 : dataset1Data, dataset2: dataset2Data})
          setNavItems(_navItems)
          setScale(_scaleItems)
        }
      } 
    }

  }, [props.data])




  const dataset1 = {
    label: dataSet["dataset1"][activeTab] ? dataSet["dataset1"][activeTab]["attr"]["dataset1"] : "1",
    fill: true,
    data: dataSet["dataset1"][activeTab] ? dataSet["dataset1"][activeTab]["data"].slice(-10) : [],
    backgroundColor: "rgba(92, 37, 141, 0.06)",
    borderColor: "#5C258D",
    pointBorderColor: "#5C258D",
    pointBackgroundColor: dataSet["dataset1"][activeTab] ? 
      dataSet["dataset1"][activeTab]["status"].map(val => {
        if (val === "OK") {return "#00FF00"}
        else if (val === "ALARM") {return "#FF0000"}
        else return "#5C258D"
      }).slice(-10) 
      : 
      [],
    shadowOffsetX: 3,
    shadowOffsetY: 3,
    shadowBlur: 10,
    shadowColor: "rgba(0, 196, 134, 0.5)",
    pointRadius: 4,
    pointBevelWidth: 3,
    pointBevelHighlightColor: "rgba(255, 255, 255, 0.75)",
    pointBevelShadowColor: "rgba(0, 196, 134, 0.5)",
    pointHoverRadius: 6,
    pointHoverBevelWidth: 4.5,
    pointHoverInnerGlowWidth: 20,
    lineTension: 0,
    pointHoverInnerGlowColor: `rgba(0, 196, 134, 0.5)`,
    pointHoverOuterGlowWidth: 20,
    pointHoverOuterGlowColor: `rgba(0, 196, 134, 0.5)`
  };

  const dataset2 = {
    label: dataSet["dataset2"][activeTab] ? dataSet["dataset2"][activeTab]["attr"]["dataset2"] : "2",
    fill: true,
    data: dataSet["dataset2"][activeTab] ? dataSet["dataset2"][activeTab]["data"].slice(-10) : [],
    backgroundColor: "rgba(255, 64, 129, 0.06)",
    borderColor: "#ff4081",
    pointBorderColor: "#ff4081",
    pointBackgroundColor: dataSet["dataset2"][activeTab] ? 
    dataSet["dataset2"][activeTab]["status"].map(val => {
      if (val === "OK") {return "#00FF00"}
      else if (val === "ALARM") {return "#FF0000"}
      else return "#ff4081"
    }).slice(-10) 
    : 
    [],
    lineTension: 0,
    shadowOffsetX: 3,
    shadowOffsetY: 3,
    shadowBlur: 10,
    shadowColor: "rgba(103, 116, 132, 0.5)",
    pointRadius: 4,
    pointBevelWidth: 3,
    pointBevelHighlightColor: "rgba(255, 255, 255, 0.75)",
    pointBevelShadowColor: "rgba(103, 116, 132, 0.5)",
    pointHoverRadius: 6,
    pointHoverBevelWidth: 4.5,
    pointHoverInnerGlowWidth: 20,
    pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
    pointHoverOuterGlowWidth: 20,
    pointHoverOuterGlowColor: `rgba(103, 116, 132, 0.5)`
  };

  const data = {
    labels: dataSet["dataset1"]["attr"] ? dataSet["dataset1"]["attr"]["date"].slice(-10) : [],
    datasets: (!isNaN(dataset1.data[0]) && !isNaN(dataset2.data[0])) ? [dataset1, dataset2] : (isNaN(dataset2.data[0]) ? [dataset1] : [dataset2]),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: "top",
      align: "end",
      display: true,
      label: {
        usePointStyle: true
      }
    },
    // tooltips: {
    //     mode: "index",
    //     intersect: false
    // },
    hover: {
      mode: "nearest",
      intersect: true
    },
    spanGaps: true,
    tooltips: {
      enabled: false,
      custom: customTooltip
    },
    scales: {
      xAxes: [
        {
          display: true,
          scaleLabel: {
            display: false,
            labelString: "Month"
          },
          ticks: {
            fontColor: "#6c757d",
            color: "#6c757d",
            zeroLineColor: "#6c757d",
            fontStyle: "bold"
          },
          gridLines: {
            display: true,
            color: "rgba(0,0,0, 0.1)",
            zeroLineColor: "#6c757d"
          }
        }
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            labelString: scale[activeTab]
          },
          ticks: {
            display: true,
            max: dataSet["dataset2"][activeTab] ? 
              (!isNaN(dataSet["dataset2"][activeTab]["data"][0]) ? 
                Math.max(...dataSet["dataset1"][activeTab]["data"], ...dataSet["dataset2"][activeTab]["data"])*1.1 
                : 
                Math.max(...dataSet["dataset1"][activeTab]["data"])*1.1) 
              : 
              1000,
            min: dataSet["dataset2"][activeTab] ? 
              (!isNaN(dataSet["dataset2"][activeTab]["data"][0]) ? 
                Math.min(...dataSet["dataset1"][activeTab]["data"], ...dataSet["dataset2"][activeTab]["data"])*0.9 
                : 
                Math.min(...dataSet["dataset1"][activeTab]["data"])*0.9) 
              : 
              0,

            /*

            min: !isNaN(dataset2.data[0]) ? (dataSet["dataset2"][activeTab] ? 
            Math.min(Math.min(...dataSet["dataset2"][activeTab]["data"]), Math.min(...dataSet["dataset1"][activeTab]["data"])) - 
            parseInt((Math.min(Math.min(...dataSet["dataset2"][activeTab]["data"]), Math.min(...dataSet["dataset1"][activeTab]["data"])) / 10)) : 5) : 
            Math.min(Math.min(...dataSet["dataset1"][activeTab]["data"]) , Math.min(...dataSet["dataset1"][activeTab]["data"]) / 10),
            */
            fontColor: "#6c757d",
            fontStyle: "bold"
          },
          gridLines: {
            display: false,
            color: "rgba(0,0,0, 0.1)",
            zeroLineColor: "#6c757d"
          },
          afterTickToLabelConversion: function(scaleInstance) {
            // set the first and last tick to null so it does not display
            // note, ticks[0] is the last tick and ticks[length - 1] is the first
            scaleInstance.ticks[0] = null;
            scaleInstance.ticks[scaleInstance.ticks.length - 1] = null;
  
            // need to do the same thing for this similiar array which is used internally
            scaleInstance.ticksAsNumbers[0] = null;
            scaleInstance.ticksAsNumbers[scaleInstance.ticksAsNumbers.length - 1] = null;
          },
        }
      ]
    }
  };
  return (

    <PageviewsChartWrapper>
      <div className="page-view-chart-widget-card roe-shadow-2">
      {
      (navItems[0] && navItems[1] && navItems[2] && navItems[3] && navItems[4] && navItems[5] && navItems[6]) &&
      <Nav tabs>

        <NavItem key={0}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[0]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[0]["key"]);
            }}
          >
            {navItems[0]["title"]}
          </NavLink>
        </NavItem>      
        <NavItem key={1}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[1]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[1]["key"]);
            }}
          >
            {navItems[1]["title"]}
          </NavLink>
        </NavItem>      
        <NavItem key={2}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[2]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[2]["key"]);
            }}
          >
            {navItems[2]["title"]}
          </NavLink>
        </NavItem>      
        <NavItem key={3}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[3]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[3]["key"]);
            }}
          >
            {navItems[3]["title"]}
          </NavLink>
        </NavItem>   
        <NavItem key={4}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[4]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[4]["key"]);
            }}
          >
            {navItems[4]["title"]}
          </NavLink>
        </NavItem> 
        <NavItem key={5}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[5]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[5]["key"]);
            }}
          >
            {navItems[5]["title"]}
          </NavLink>
        </NavItem> 
        <NavItem key={6}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[6]["key"] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[6]["key"]);
            }}
          >
            {navItems[6]["title"]}
          </NavLink>
        </NavItem>    
      </Nav>
      
      } 
        <div className="header fs-20"> 
          <div className="row">     
            <p>
              {
                dataSet["dataset1"][activeTab] ? dataSet["dataset1"][activeTab]["attr"]["dataset1"] : null
              }
            </p>
            <p>
              &nbsp;&nbsp; & &nbsp;&nbsp;
            </p>
            <p>
              {
                dataSet["dataset2"][activeTab] ? dataSet["dataset2"][activeTab]["attr"]["dataset2"] : null
              }
            </p>
          </div>
        </div>
        <div className="analytics">
          <Line data={data} height={300} options={options} />
        </div>
      </div>
    </PageviewsChartWrapper>

  );
};

export default PageviewsChartWidget;
